import React, { memo } from "react";

import { ShowcaseCard } from "ui/components/Showcase";

/** Udjeli za kružni graf flote: slobodno, iznajmljeno, na servisu (zbroj 100). */
const FLEET_SHARES = [
  { label: "Slobodno", value: 18, percent: 75, color: "#3B82F6" },
  { label: "Iznajmljeno", value: 3, percent: 13, color: "#FBBF24" },
  { label: "Na servisu", value: 3, percent: 12, color: "#93C5FD" },
];

/** Polumjer s opsegom 100 — dasharray i pomak segmenta su tada izravno postoci. */
const DONUT_RADIUS = 15.9155;

/** Segmenti grafa: svaki počinje gdje prethodni završava. */
const DONUT_SEGMENTS = FLEET_SHARES.map((share, index) => ({
  ...share,
  start: FLEET_SHARES.slice(0, index).reduce((sum, item) => sum + item.percent, 0),
}));

/** Slajd "Cijela flota": kartica vozila s fotografijom, graf flote i obavijest o registraciji. */
const FleetSlide: React.FC = () => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-0 w-[17rem]" delay={0}>
        <div className="relative h-[13.5rem] p-[10px] rounded-t-lg bg-gradient-to-br from-amber-200 to-amber-300 overflow-hidden">
          <div className="absolute -right-6 -top-8 w-28 h-28 rounded-full bg-white/30" />
          <img
            src="/media/images/vehicles/vehicle-2.png"
            alt=""
            className="relative w-full h-full object-contain drop-shadow-xl"
          />
        </div>
        <div className="p-5">
          <div className="flex items-center justify-between">
            <div className="text-sm font-bold text-slate-800">Kia Sorento</div>
            <span className="px-2 py-0.5 rounded-full bg-emerald-50 text-[0.65rem] font-semibold text-emerald-600">
              Slobodno
            </span>
          </div>
          <div className="mt-1 text-[0.7rem] text-slate-400">ZG 1234 AB · 84.320 km</div>
          <div className="mt-3">
            <div className="flex justify-between text-[0.65rem] text-slate-500">
              <span>Idući servis</span>
              <span className="font-semibold text-slate-700">za 1.200 km</span>
            </div>
            <div className="mt-1 h-1.5 rounded-full bg-slate-100">
              <div className="h-full w-4/5 rounded-full bg-gradient-to-r from-blue-500 to-sky-400" />
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Pregled flote</div>
          <div className="mt-3 flex items-center gap-3">
            <div className="relative w-16 h-16 flex-shrink-0">
              <svg className="w-16 h-16 -rotate-90" viewBox="0 0 36 36" aria-hidden="true">
                <circle cx="18" cy="18" r={DONUT_RADIUS} fill="none" stroke="#F1F5F9" strokeWidth="4" />
                {DONUT_SEGMENTS.map((share) => (
                  <circle
                    key={share.label}
                    cx="18"
                    cy="18"
                    r={DONUT_RADIUS}
                    fill="none"
                    stroke={share.color}
                    strokeWidth="4"
                    strokeDasharray={`${share.percent} ${100 - share.percent}`}
                    strokeDashoffset={-share.start}
                  />
                ))}
              </svg>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <span className="text-sm font-bold leading-none text-slate-800">24</span>
                <span className="text-[0.55rem] text-slate-400">vozila</span>
              </div>
            </div>
            <div className="space-y-1.5">
              {FLEET_SHARES.map((share) => (
                <div key={share.label} className="flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full" style={{ backgroundColor: share.color }} />
                  <span className="text-[0.65rem] text-slate-500">{share.label}</span>
                  <span className="text-[0.65rem] font-bold text-slate-700">{share.value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-3rem] w-[15rem]" delay={0.5}>
        <div className="flex items-center gap-3 px-4 py-3.5">
          <span className="flex items-center justify-center w-8 h-8 rounded-lg bg-amber-100 flex-shrink-0">
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <rect x="3" y="5" width="18" height="16" rx="2" />
              <path d="M16 3v4M8 3v4M3 10h18" />
            </svg>
          </span>
          <div>
            <div className="text-[0.7rem] font-bold text-slate-800">Registracija ističe</div>
            <div className="text-[0.65rem] text-slate-400">ZG 1234 AB · za 12 dana</div>
          </div>
        </div>
      </ShowcaseCard>
    </>
  );
};

export default memo(FleetSlide);
